import { createRouter, createWebHistory } from 'vue-router'
import Recruit from '@/views/Recruit'
import Layout from '@/layout/Layout'
const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/recruit',
    children: [
      {
        path: '/recruit',
        name: 'Recruit',
        component: Recruit
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: () => import('@/views/404.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/employ/'),
  routes
})

export default router
